export default class WaveFile {

    public id: string;
    public path: string;
}